import { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { userLogout } from "../../api/userService";
import Button from "../Button/Button";
import Logo from "../Logo/Logo";
import NavbarLink from "../NavbarLink/NavbarLink";
import UserContext from "../../context/UserContext";
import "./NavBar.scss";
import LogOutIconVector from "../../assets/images/svgComponents/LogOutIconVector";

const NavBar = () => {
  const { user, setUser } = useContext(UserContext);
  const navigate = useNavigate();

  const nameLongerThanNine = () => {
    return user.childName.length > 9;
  };
  const [showTruncated, setShowTruncated] = useState(true);

  const handleLogout = () => {
    userLogout(setUser);
    navigate("/login");
  };

  const getChildName = () => {
    if (user.childName == null) return "loading...";

    if (nameLongerThanNine() && showTruncated) {
      return user.childName.substring(0, 8) + "...";
    }

    return user.childName;
  };

  const getSchoolId = () => {
    if (user.schoolId == null) return "loading...";

    return user.schoolId.substring(0, 4);
  };

  const getNameLength = () => {
    return user.childName.length;
  };
  const minimumCharBeforeFontDecrease = () => {
    return 5;
  };

  return (
    <nav className="nav-bar">
      <div>
        <Link to="/dashboard">
          <Logo />
        </Link>
        <NavbarLink text={"Introduction"} to="/story-container" />
        <NavbarLink text={"Swing Game"} to="/swing-game-instructions" />
        <NavbarLink text={"Blending Game"} to="/blending-game-instructions" />
        <NavbarLink text={"Dashboard"} to="/dashboard" />
        <NavbarLink text={"Stats"} to="/stats-page" />
        <NavbarLink text={"Add Avatar"} to="/avatar-page" />

        <div
          className={
            showTruncated
              ? "nav-bar__user-info"
              : "nav-bar__user-info--expanded"
          }
        >
          <img className="nav-bar__avatar" src={user.avatar} alt="avatar" />

          {getNameLength() > minimumCharBeforeFontDecrease() ? (
            <div>
              <h2
                className={"nav-bar__name--small"}
                onClick={() => {
                  setShowTruncated(!showTruncated);
                }}
              >
                {getChildName()}
              </h2>
            </div>
          ) : (
            <h2 className={"nav-bar__name"}>{getChildName()}</h2>
          )}
        </div>
        <p className="nav-bar__school-name">{getSchoolId()}</p>
      </div>
      <Button
        onClick={handleLogout}
        className="logout-button"
        label="Logout"
        isLabelRight={true}
        Icon={LogOutIconVector}
        isTertiary
      />
    </nav>
  );
};

export default NavBar;
